import * as React from 'react';

import {GridList} from 'shells/grid-list/grid-list';
import {Illustration} from 'shells/illustrations/illustration';
import {Stack} from 'shells/layout/stack/stack';
import {LoadingPage} from 'shells/loading-page/loading-page';
import {Body} from 'shells/typography/body';

import {ConnectStep} from './connect-step';
import {useGetConnectNextSteps} from './graphql/hooks/use-get-connect-next-steps';
import {getConnectStepConfig} from './helpers';

type Props = {
    onClose?: () => void;
};

export function ConnectionNextSteps(props: Props) {
    const {connectNextSteps, isLoading} = useGetConnectNextSteps();

    if (isLoading || !connectNextSteps) {
        return (
            <div>
                <LoadingPage padding={64} />
            </div>
        );
    }

    const connectStepsMapped = connectNextSteps.nextSteps
        .map((step) => getConnectStepConfig(step))
        .filter(Boolean)
        .slice(0, 3);

    const [firstStep, ...remainingSteps] = connectStepsMapped;

    return (
        <Stack spacing={16}>
            {connectNextSteps.isComplete ? (
                <>
                    <Body size='large' color='dark' isBold={true}>
                        Nice work! Your tools are connected.
                    </Body>
                    <Illustration src='trial-onboarding/calendar-emails-meetings' />
                </>
            ) : (
                <>
                    <Body size='large' color='dark' isBold={true}>
                        Connect or sync other tools to streamline your workflow
                    </Body>
                    {firstStep && (
                        <ConnectStep
                            key={firstStep.description}
                            step={firstStep}
                            onClose={props.onClose}
                        />
                    )}
                    {remainingSteps.length > 0 && (
                        <GridList numColumns={remainingSteps.length > 1 ? 2 : 1}>
                            {remainingSteps.map((step) => (
                                <ConnectStep
                                    // @ts-expect-error
                                    key={step.description}
                                    // @ts-expect-error
                                    step={step}
                                    onClose={props.onClose}
                                />
                            ))}
                        </GridList>
                    )}
                </>
            )}
        </Stack>
    );
}
